import React from 'react';
import { ReactFlow, Background, Handle, Position } from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import logoEsm from '../../../../images/Logo/logoESM.png';
import logoHsv from '../../../../images/Logo/Logo HSV_01.png';

// --- CUSTOM NODES ---

export const EsmLogoNode = () => (
  <div style={{ width: '200px', background: 'white', padding: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <img src={logoEsm} alt="ESM Logo" style={{ height: '60px' }} />
    <Handle type="source" position={Position.Bottom} style={{ visibility: 'hidden' }} />
  </div>
);

export const BlueHeaderNode = ({ data }) => (
  <div style={{ width: '350px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
    <Handle type="target" position={Position.Top} style={{ visibility: 'hidden' }} />
    
    <div style={{ height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#3b82f6', color: 'white', padding: '0 15px', textAlign: 'center', fontWeight: 'bold', fontSize: '18px', textTransform: 'uppercase', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
      {data.header}
    </div>
    
    <div style={{ background: 'white', border: '2px solid #3b82f6', borderRadius: '12px', padding: '20px', fontSize: '18px', color: '#1e3a8a', fontStyle: 'italic', lineHeight: '1.5', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
      {data.content}
    </div>
  </div>
);

export const HsvCenterNode = ({ data }) => (
  <div style={{ width: '350px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
    <Handle type="target" position={Position.Top} style={{ visibility: 'hidden' }} />
    
    <div style={{ height: '80px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <img src={logoHsv} alt="HSV Logo" style={{ height: '60px', objectFit: 'contain' }} />
    </div>
    
    <div style={{ background: 'white', border: '2px solid #3b82f6', borderRadius: '12px', padding: '20px', fontSize: '18px', color: '#1e3a8a', fontStyle: 'italic', textAlign: 'center', lineHeight: '1.5', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
      {data.content}
    </div>
  </div>
);

export const GreenSolidNode = ({ data }) => (
  <div style={{ width: data.width || '300px', background: '#16a34a', borderRadius: '12px', padding: '20px', minHeight: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
    <Handle type="target" position={Position.Left} style={{ visibility: 'hidden', top: '40px' }} />
    <Handle type="source" position={Position.Right} style={{ visibility: 'hidden', top: '40px' }} />
    {data.label}
  </div>
);

export const BlueSolidNode = ({ data }) => (
  <div style={{ width: data.width || '300px', background: '#026bc6', borderRadius: '12px', padding: '20px', minHeight: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
    <Handle type="target" position={Position.Left} style={{ visibility: 'hidden', top: '40px' }} />
    <Handle type="source" position={Position.Right} style={{ visibility: 'hidden', top: '40px' }} />
    {data.label}
  </div>
);

export const BlueBorderNode = ({ data }) => (
  <div style={{ width: data.width || '300px', background: 'white', border: '2px solid #3b82f6', borderRadius: '8px', padding: '10px 20px', minHeight: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', fontWeight: '600', color: '#3b82f6', textAlign: 'center' }}>
    <Handle type="target" position={Position.Left} style={{ visibility: 'hidden', top: '40px' }} />
    <Handle type="source" position={Position.Right} style={{ visibility: 'hidden', top: '40px' }} />
    {data.label}
  </div>
);

export const GreenDashedNode = ({ data }) => (
  <div style={{ width: data.width || '300px', background: 'white', border: '2px dashed #16a34a', borderRadius: '8px', padding: '10px 20px', minHeight: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', fontWeight: '600', color: '#16a34a', textAlign: 'center' }}>
    <Handle type="target" position={Position.Left} style={{ visibility: 'hidden', top: '40px' }} />
    <Handle type="source" position={Position.Right} style={{ visibility: 'hidden', top: '40px' }} />
    {data.label}
  </div>
);

export const HsvLogoDashedNode = ({ data }) => (
  <div style={{ width: data.width || '300px', background: 'white', border: '2px dashed #16a34a', borderRadius: '8px', padding: '10px 20px', minHeight: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <Handle type="target" position={Position.Left} style={{ visibility: 'hidden', top: '40px' }} />
    <Handle type="source" position={Position.Right} style={{ visibility: 'hidden', top: '40px' }} />
    <img src="/images/Logo/Logo_HSV.png" alt="HSV" style={{ height: '60px', objectFit: 'contain' }} />
  </div>
);

export const GreenBorderNode = ({ data }) => (
  <div style={{ width: data.width || '300px', background: 'white', border: '2px solid #16a34a', borderRadius: '8px', padding: '10px 20px', minHeight: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', fontWeight: '600', color: '#16a34a', textAlign: 'center' }}>
    <Handle type="target" position={Position.Left} style={{ visibility: 'hidden', top: '40px' }} />
    <Handle type="source" position={Position.Right} style={{ visibility: 'hidden', top: '40px' }} />
    {data.label}
  </div>
);

export const ContentBoxNode = ({ data }) => (
  <div className="content-box-node" style={{ width: data.width || '500px', background: 'white', border: '2px solid #3b82f6', borderRadius: '12px', padding: '20px', minHeight: '80px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', fontSize: '18px', color: '#1e3a8a', fontStyle: 'italic', textAlign: 'left', lineHeight: '1.6' }}>
    <Handle type="target" position={Position.Left} style={{ visibility: 'hidden', top: '40px' }} />
    <Handle type="source" position={Position.Right} style={{ visibility: 'hidden', top: '40px' }} />
    <div>{data.label}</div>
  </div>
);

// Node Types Object
export const nodeTypes = {
  esmLogo: EsmLogoNode,
  blueHeader: BlueHeaderNode,
  hsvCenter: HsvCenterNode,
  greenSolid: GreenSolidNode,
  blueSolid: BlueSolidNode,
  blueBorder: BlueBorderNode,
  greenDashed: GreenDashedNode,
  hsvLogoDashed: HsvLogoDashedNode,
  greenBorder: GreenBorderNode,
  contentBox: ContentBoxNode,
};
